import React, { useEffect, useState } from "react";
export default function Checkbox(props) {
    var [value, setValue] = useState(props.checked)


    var onChange = (e) => {
        setValue(!value)
        props.onChange(e)
    }

    useEffect(() => {
        setValue(props.checked)
    }, [props.checked])
    return (
        <div className="form-check form-switch col-12 switchBtn " >
            <label className="form-check-label w-100 " htmlFor={props.name}>{props.title}</label>
            <label className="text-danger text-small p-0 m-0" style={{fontSize:'0.8rem'}}>{props?.desc}</label>

            <input className="form-check-input "
                type="checkbox"
                value={!value}
                checked={value}
                id={props.name}
                onKeyDown={props.onKeyDown}
                name={props.name}
                onChange={onChange} />
        </div>
    )
}